export default "__VITE_ASSET__CCHc7ozu__"